<template>
  <div class="row">
    <div class="col-xl-12 col-xs-12 vcenter" >
      <div class="form-middle">
          <div class="title-form">
              <h2>Let's get you logged in</h2>
              <span class="bigger"> Create a new password. </span>
          </div>
          <div>
            <div class="w-form">
              <div v-if="loader">
                  <flash-message></flash-message>
                  <div class="spinner">
                      <div class="double-bounce1"></div>
                      <div class="double-bounce2"></div>
                  </div>
              </div>
              <div v-if="!loader">
                  <form id="email-form" @submit.prevent="newPassword" name="email-form" data-name="Email Form">
                      <flash-message></flash-message>
                      <div class="field">
                          <input type="password" v-model="form.password" placeholder="Password" class="input-form" required>
                          <label for="password">New Password</label>
                      </div>
                      <div class="field">
                          <input type="password" v-model="form.repeat_password" placeholder="Re-type Password" class="input-form" required>
                          <label for="password">Re-type Password</label>
                      </div>
                      <input type="submit" value="Set new password" class="btn btn-large">
                  </form>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'new_password',
  mounted () {
    this.messageStorage.destroyAll()
    this.$http.post('/api/user/validate_password_key', {
      reset_password_key: this.$route.params.password_secret_key }
    ).then((res) => {
      this.loader = false
    }).catch((err) => {
      // console.log(err)
      this.messageStorage.destroyAll()
      this.messageStorage.flash('Error Loading Page', 'error')
    })
  },
  data () {
    return {
      loader: true,
      form: {
        password: '',
        repeat_password: '',
        reset_password_key: this.$route.params.password_secret_key
      },
      messageStorage: this.flash()
    }
  },
  methods: {
    newPassword: function () {
      if (this.form.password !== this.form.repeat_password) {
        this.messageStorage.destroyAll()
        this.messageStorage.flash('The password does not match', 'error')
        return
      }
      this.$http.post('/api/user/new_password', this.form).then((res) => {
        this.messageStorage.destroyAll()
        this.form = {
          password: '',
          repeat_password: '',
          password_secret_key: ''
        }
        this.$router.push({ name: 'login', query: { new_password: true } })
        this.$router.go()
      }).catch((err) => {
        this.messageStorage.destroyAll()
        this.messageStorage.flash(err.data.error, 'error')
        // this.form.password = ""
      })
    }
  }
}
</script>
